/**
 * 任意の桁で四捨五入した上で、三桁ごとに区切る関数
 * @param {number} value 四捨五入する数値
 * @param {number} base どの桁で四捨五入するか（10→10の位、0.1→小数第１位）
 * @return {number} 四捨五入した値
 */
export const roundAndAddThousandsSeparator = (number: number, base: number): string => {
  return (Math.round(number * base) / base).toLocaleString()
}
